<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    
            <FormItem :label="$t('orderManage.addModel.orderId')" prop="orderId" style="width: 500px">
                <Input type="text" v-model.trim="formData.orderId" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('orderManage.addModel.orderDate')" prop="orderDate" style="width: 500px">
                <DatePicker type="date" :value="formData.orderDate1" :placeholder="$t('selectPlaceholder')" @on-change='selectT'  format="yyyy-MM-dd" style="width: 380px"></DatePicker>
            </FormItem>

            <FormItem :label="$t('orderManage.addModel.orderProductType')" prop="orderProductId"  style="width: 500px">
                <!-- <SearchSelect ref="productType" :needName="$t('orderManage.addModel.needPublish')"  :url="productsManageListUrl" listName="productList" labelNameNew="name" :selectUrlQuery='selectUrlQuery' labelName='productType' isMultiple='2'  valName='id' keyword="productType" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'orderProductId')"></SearchSelect> -->
                
                <SearchSelectRecycle ref="productTypeRef" refName="productTypeRef"  listName="productList" :needName="$t('orderManage.addModel.needPublish')"  :url="productsManageListUrl" labelNameNew="name" :selectUrlQuery='selectUrlQuery' labelName='productType' isMultiple='2'  valName='id' keyword="productType" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'orderProductId')"></SearchSelectRecycle>
            </FormItem>

             <FormItem :label="$t('orderManage.addModel.frequency')" prop="frequency" style="width: 500px">
                <!-- <InputNumber :min="0" v-model="formData.frequency" :active-change="false" :placeholder="$t('inputPlaceholder')"></InputNumber> -->
                <Input type="text" v-model.trim="formData.frequency" maxlength="20" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('orderManage.addModel.hardware')" prop="hardware" style="width: 500px">
                <template slot="label">
                   <span>{{$t('orderManage.addModel.hardware')}}</span>
                   <Tooltip>
                       <Icon type="ios-help-circle-outline" />
                       <div slot="content" style="white-space: normal">
                            <p>WIFI/蓝牙设备：型号-V000R000C00B000</p>
                            <p>二进制LoRaWan设备：00.00</p>
                            <!-- <p>HyECO平台设备：0.0.0</p> -->
                        </div>
                   </Tooltip >
                 </template>

                 <Input type="text" v-model.trim="formData.hardware" :placeholder="$t('inputPlaceholder')" ></Input>

            </FormItem>

            <FormItem :label="$t('orderManage.addModel.firmware')" prop="firmware" style="width: 500px">
                <template slot="label">
                   <span>{{$t('orderManage.addModel.firmware')}}</span>
                   <Tooltip>
                       <Icon type="ios-help-circle-outline" />
                       <div slot="content" style="white-space: normal">
                            <p>WIFI/蓝牙设备：型号-V000R000C00B000</p>
                            <p>二进制LoRaWan/HyECO平台设备：00.00</p>
                            <!-- <p>HyECO平台设备：0.0.0</p> -->
                        </div>
                   </Tooltip >
                 </template>

                <Input type="text" v-model.trim="formData.firmware" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>


            <FormItem :label="$t('orderManage.addModel.qty')" prop="qty" style="width: 500px">
                <InputNumber  :min="1" :step="1" :precision='0' v-model="formData.qty" :placeholder="$t('inputPlaceholder')" ></InputNumber>
            </FormItem>

            <FormItem :label="$t('orderManage.addModel.remark')" prop="remark" style="width: 500px">
                <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>


            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SearchSelect from '../../common/selectList.vue';
import SearchSelectRecycle from '@/views/common/selectListRecycle.vue';  //20220415
import { mapState } from 'vuex'


    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelect,
            SearchSelectRecycle
        },
        data() {
            return {   
                productsManageListUrl: this.config.urlArray.productsManageList,
                selectUrlQuery:{published:true,page:1,limit:10000},
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    orderId: '',
                    orderName:'',
                    orderDate:'',
                    orderDate1:'',
                    orderProductId:'',
                    hardware:'',//硬件
                    firmware:'',//固件
                    qty:1,
                    remark:'',
                    frequency:'',//工作频率，选填
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                    orderId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        // {type: 'string', pattern: /^[0-9]+$/, message: this.$t('ruleCustom.pageId'), trigger:'blur'},
                    ],
                    orderDate: [
                        {required: true, message: this.$t('required'),trigger: 'change',pattern: /.+/  },
                    ],
                    orderProductId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    hardware: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    firmware: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    qty: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                }
             } 

        },
        created(){
           
        },
        methods: {
         
            selectT(val){
               this.formData['orderDate1'] = val
               this.formData['orderDate'] = new Date(val).getTime()    
            },
            setSelectVal(e,key){
                // console.log('e',e)
                 this.formData[key] = e.nameVal+''
            },
            setSelectValNew(e,key){
                // console.log('eeee',e)
                // console.log('keykeykey',key)
                let obj = {'orderProductId':'id'}
              if(e){
                   this.formData[key] = e[obj[key]]+''
              }else{
                   this.formData[key] = ''
              }

            },
            openOrClose(value) {
                if(value === true) {   
                    
                    this.title = this.type == 1?this.$t('orderManage.addModel.title'):this.$t('orderManage.editButton')
             
                    if(this.type==2){

                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }

                        this.formData.orderId = this.editFormData.orderName;
                        this.formData.orderProductId = this.editFormData.orderProductId+'';
                        this.formData.orderDate1 = moment(this.editFormData.orderDate).format('YYYY-MM-DD')

                        this.$nextTick(()=>{//select赋值，图片赋值
                            // this.$refs.productType.setDefVal(Number(this.formData.orderProductId));
                            try {
                                this.$refs.productTypeRef.setDefVal({
                                    id:this.formData.orderProductId*1,
                                })

                           } catch (error) {
                            this.$refs.productTypeRef.clearVal()
                           }
                        });

                    }else{
                        this.$nextTick(()=>{//select赋值
                            // this.$refs.productType.setQuery(null)
                            this.$refs.productTypeRef.getData()
                        }); 
                    }

     


                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    // this.$refs.productType.clearVal();
                    this.$refs.productTypeRef.clearVal();
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // console.log('this.formData',this.formData)
                        this.disabled = true;
                        this.formData.orderName = this.formData.orderId

                        let url = this.type==1?this.config.urlArray.orderAdd:this.config.urlArray.orderSet
                        let params = {...this.formData,dealerId:this.selectId}
                        if(this.type==2) params.id = this.editFormData.id

                        console.log('params',params)

                        this.axios.post(url, params).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false})
                            
                        }).catch((err) => {
                            this.disabled = false
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.qty = 1
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/.ivu-tooltip-inner { 
    width: 290px !important;
}

</style>